import React, { InputHTMLAttributes } from 'react';

import styles from '../Fields.module.css';

function TextField({
  className = '',
  ref,
  ...fieldProps
}: InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> }) {
  return (
    <input
      type='text'
      ref={ref}
      className={`${styles.inputField} ${className}`}
      id={fieldProps?.name && !fieldProps?.id ? fieldProps?.name : fieldProps?.id}
      name={fieldProps?.id && !fieldProps?.name ? fieldProps?.id : fieldProps?.name}
      {...fieldProps}
    />
  );
}

export default TextField;
